import React from "react";
const Signin = React.lazy(() => import("./Authentication/Signin"));
const AllPrograms = React.lazy(() => import("./All Programs/index"));
const MyCourses = React.lazy(() => import("./My Courses/index"));
const Resume = React.lazy(() => import("./Resume/index"));
const ProfileSetting = React.lazy(() => import("./ProfileSetting/index"));
const CardDashboard = React.lazy(() => import("./MyCardDashboard/index"));
const Lms = React.lazy(() => import("./Lms/index"));
const Lms_V1 = React.lazy(() => import("./Lms/index_v1"));
const Lms_V1_test = React.lazy(() => import("./Lms/index_v1_test"));
const Challenge = React.lazy(() => import("./Challenge/index"));
const Internships = React.lazy(() => import("./Internships/index"));
const Certificate = React.lazy(() => import("./Certificates/index"));
const PaymentModal = React.lazy(() => import("./PaymentModal/index"));
const ReferAndEarn = React.lazy(() => import("./ReferAndEarn"));
const MyCoursesV1 = React.lazy(() => import("./My Courses/index"));
const LmsV1 = React.lazy(() => import("./Lms/index_v1_test"));
const ResumeV1 = React.lazy(() => import("./Resume/index"));
const ChallengeV1 = React.lazy(() => import("./Challenge/index"));
const InternshipsV1 = React.lazy(() => import("./Internships/index"));
const InternshipsV2 = React.lazy(() => import("./Internships_v2/index"));
const InternshipsV3 = React.lazy(() => import("./Internships_v3/index"));
const AiEvaluationV1 = React.lazy(() => import("./AIEvaluation/index"));
const AiEvaluationV2 = React.lazy(() => import("./AIEvaluation_v1/index"));
const AiEvaluationV1_Public = React.lazy(
  () => import("./AIEvaluation/publicEval")
);
const ReferAndEarn_V1 = React.lazy(() => import("./ReferAndEarn"));
const ProfileSetting_V1 = React.lazy(() => import("./ProfileSetting/index"));
const Notes = React.lazy(() => import("./Notes/Notes"));
export {
  Signin,
  AllPrograms,
  MyCourses,
  Resume,
  ProfileSetting,
  CardDashboard,
  Lms,
  Challenge,
  Internships,
  Certificate,
  PaymentModal,
  Lms_V1,
  ReferAndEarn,
  MyCoursesV1,
  LmsV1,
  Lms_V1_test,
  ResumeV1,
  ChallengeV1,
  InternshipsV1,
  InternshipsV2,
  InternshipsV3,
  AiEvaluationV1,
  ReferAndEarn_V1,
  ProfileSetting_V1,
  Notes,
  AiEvaluationV1_Public,
  AiEvaluationV2,
};

// Creating Key value pair for Program Dashboard
